import React from 'react';
import PropTypes from 'prop-types';
import PageWrapper from '../Wrapper/PageWrapper';
import LoginRegisterOrOther from '../Account/LoginRegisterOrOther';
import './Page.css';

export default function Login(props) {
  return (
    <PageWrapper
      locale={props.locale}
      setLocale={props.setLocale}
      services={props.services}
      dataStorage={props.dataStorage}
      setDataStorage={props.setDataStorage}
    >
      <LoginRegisterOrOther
        services={props.services}
        locale={props.locale}
        dataStorage={props.dataStorage}
        setDataStorage={props.setDataStorage}
      />
    </PageWrapper>
  );
}

Login.propTypes = {
  locale: PropTypes.string.isRequired,
  setLocale: PropTypes.func.isRequired,
  services: PropTypes.objectOf(PropTypes.object).isRequired,
  dataStorage: PropTypes.objectOf(PropTypes.any).isRequired,
  setDataStorage: PropTypes.func.isRequired,
};
